import { selectCurrentPlanByProduct } from './selectCurrentPlanByProduct'

export const selectCurrentInbox = state => {
  return selectCurrentPlanByProduct(state, 'inbox')
}
